import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import configureStore from 'store';
import reset from 'styles/reset';
import Route from 'route';
import registerServiceWorker from 'registerServiceWorker';

const GlobalStyle = createGlobalStyle`
  ${reset}
`
const store = configureStore();

const rootElement = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <Provider store={store}>
    <GlobalStyle/>
    <Route />
  </Provider>,
  rootElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx